<template>
  <NuxtPwaManifest />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import packageJson from './package.json';
import {
  defaultUserNotificationSize,
  useUserNotificationsStore,
} from '~/stores/user-notification';

const i18n = useI18n();
const { $client } = useNuxtApp();
const userNotificationsStore = useUserNotificationsStore();

const isNotificationSent = ref(false);

const fetchUserNotifications = () => {
  userNotificationsStore.fetch({ size: defaultUserNotificationSize });
};

const visibilityChangeHandler = async () => {
  if (document.hidden) {
    return;
  }

  fetchUserNotifications();

  // Check Server Version
  const serverAppVersion = await $client.app.currentAppVersion.query();
  if (
    serverAppVersion.CLIENT_VERSION_CONTROLLER_EMERGENCY_DISABLED === 'true'
  ) {
    return;
  }
  if (packageJson.version !== serverAppVersion.version) {
    if (isNotificationSent.value) {
      return;
    }
    isNotificationSent.value = true;
    const answer = window.confirm(
      i18n.t('version-outdated.description', {
        buildVersion: packageJson.version,
        targetVersion: serverAppVersion.version,
      })
    );
    if (answer) {
      window.location.reload();
    }
  }
};

onMounted(() => {
  window.addEventListener('visibilitychange', visibilityChangeHandler);
});

onBeforeUnmount(() => {
  window.removeEventListener('visibilitychange', visibilityChangeHandler);
});
</script>
